<template>
    <div class='menu'>
        <!-- logo -->
        <div class="home" :class='{active:dashFlag}' @click="activeTo(0)">
            <img v-if="dashFlag" src="../../assets/img/logo-white.svg" alt="">
            <img v-else src="../../assets/img/logo-blue.svg" alt="">
        </div>

        <!-- 主菜单 -->
        <div class="main-choice" v-for="(data,index) in main_menu" :key="data.name">
            <div class='main-title' 
                :class="{
                    active:judgeActive(index)
                }"  
                @click="activeTo(index+1)">

                <img v-if="data.icon" :src="`${base_url}menu-icon/${data.icon}`">
                <div class="text">
                    {{ data.title }}
                </div>

                <i v-show="sec_menu_list[index].length" 
                    class='el-icon-arrow-right' 
                    :class="{active:judgeActive(index) && menu_on}">
                </i>
                
            </div>
            <!-- 二级菜单 -->
            <div class="second-menu" 
                :class="{active:judgeActive(index) && menu_on}">
                <div class="second-item choice" 
                    v-for="(item,i) in sec_menu_list[index]" 
                    :class="{active:i == active_sec_index[index]}"
                    :key="item.name" 
                    @click.stop="linkTo(item.name)">
                    {{ item.title }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import routerConfig from "@/router/router-config.js"

    export default {
        data(){
            return {
                activeTab:0, // 一级菜单 active
                menu_on:true,   //允许下拉框出现
                base_url:process.env.BASE_URL,
            }
        },

        computed:{
            imgget(){
                return this.$route.name == 'dashboard'?'../../assets/img/logo-white.svg':'../../assets/img/logo-blue.svg'
            },
            dashFlag(){
                return this.$route.name == 'dashboard';
            },
            main_menu(){  //主菜单
                return routerConfig
                    .find(item=>item.key == 'menu_list').children
                    .slice(1)
                    .filter(item=>{
                        let code = item.meta.code;
                        return this.$func.hasCode(code)
                    })
            },
            sec_menu_list(){  // 次级菜单
                return this.main_menu.map(item=>{
                    let children = item.children || [];
                    
                    return children.filter(item=>{
                        let meta = item.meta || {};
                        let arr = [
                            meta.code == undefined,   //无权限限制
                            this.$func.hasCode(meta.code), //有权限限制
                        ]
                        return arr.some(judge=>judge); 
                    })
                })
            },

            nowSecMenu(){
                let tab = this.activeTab; 
                return tab  
                    ?this.sec_menu_list[tab - 1]
                    :[]
            },
            //二级菜单 激活项 数组
            active_sec_index(){   
                return this.main_menu.map( ()=>{
                    return 0;
                });
            }
        },

        watch:{
			"$route"(to){
				this.menuChange(to);
			}
		},

        created(){
			this.menuChange(this.$route);
		},

        methods:{
            judgeActive(index){
                return index == this.activeTab - 1;
            },

            activeTo(index){  //通过计算 跳链
                if(index == this.activeTab){
                    this.menu_on = !this.menu_on;
                    return;
                }
                this.menu_on = true;
                this.activeTab = index;
                
                if(index == 0){
                    this.linkTo('dashboard');
                    return;
                }

                if(this.nowSecMenu.length){
                    let secIndex = this.active_sec_index[index - 1];
                    let name = this.nowSecMenu[secIndex].name
                    this.linkTo(name);
                }else{
                    this.activeSecTab = -1;
                    this.linkTo(this.main_menu[index-1].name);
                }
            },

            menuChange(route){  //根据路由，安排菜单选项active状态
                let pathArr = route.fullPath.substring(1).split("/").map(str=>str.split('?')[0]);
                
                if(pathArr[0] == "dashboard"){
                    this.activeTab = 0;
                    return;
                }
                this.main_menu.some((one,index)=>{
                    if(one.path == pathArr[0]){
                        this.activeTab = index + 1;
                        this.nowSecMenu.some((sec,i)=>{
                            if(sec.path == pathArr[1]){
                                this.active_sec_index[index] = i;
                                return true;
                            }
                        })
                        return true;
                    }
                });
			},

            // 辅助函数**************************************
            linkTo(name){   //跳链
                this.$router.push({name:name});
            },


        },
    }
</script>

<style lang="less" scoped>
    .menu{
        width:@g_menu_w;
        height:100%;
        color:#fff;
        background:#172D55;
        overflow: auto;
        // background:#364760;
    }

    // 头部logo
    .home{
        height:@g_head_h;
        // box-shadow: 0 1px 2px 0 #1d293b;
        box-sizing: border-box;
        position: relative;
        cursor: pointer;
        transition:0.3s;
        &.active{
            background:rgba(22, 163, 255, 1);
        }
        img{
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translateY(-50%) translateX(-50%);
        }
    }


    @padd:48px;

    // 主菜单
    .main-title{
        height:48px;
        line-height: 48px;
        padding-left: @padd;
        cursor: pointer;
        font-size:16px;
        transition:0.3s;
        position: relative;
        &:hover{
            // background:#48576a;
            background:#2F4A7C;
        }

        >img{
            position: absolute;
            left:10px;
            top:50%;
            transform: translateY(-50%);
        }
        
    //     .text{
    //         .icon{
    //             height: 20px;
    //             width:20px;
    //             vertical-align: middle;
    //             margin-right:15px;
    //         }

    //     }

        i{
            transition:0.3s;
            position: absolute;
            top:50%;
            transform:translateY(-50%);
            right:20px;
            &.active{
                transform: translateY(-50%) rotate(90deg);
            }
        }
    }

    // 二级菜单
    .second-menu{
        position: relative;
        overflow: hidden;
        max-height:0;
        transition:0.5s;
        background: #101E38;
        &.active{
            max-height:300px;
            padding: 5px 0px;
        }

        .second-item{
            background:#202e3d;
            padding-left: @padd;
            font-size:14px;
            height: 40px;
            line-height: 40px;
            cursor: pointer;
            transition:0.3s;
            &:hover{
                background:#2F4A7C;
            }
        }
        
    }

    // 有active的可能性
    .choice{
        &.active{   //当前激活的菜单
            background:#2F4A7C;
        }
    }
</style>